import type { BoardInput } from '../mainApi';

export type VoteIconType = NonNullable<BoardInput['voteIconType']>;

export type VoteColors = {
  myVoteColor: string;
  theirVoteColor: string;
};

export const getDefaultVoteColors = (
  voteIconType: VoteIconType | string | undefined
): VoteColors => {
  if (voteIconType === 'thumb') {
    return {
      myVoteColor: '#d4edff',
      theirVoteColor: '#129bf7',
    };
  }

  if (voteIconType === 'star') {
    return {
      myVoteColor: '#ffffd1',
      theirVoteColor: '#fefe00',
    };
  }

  if (voteIconType === 'dot') {
    return {
      myVoteColor: '#75ce1c',
      theirVoteColor: '#529610',
    };
  }

  return {
    myVoteColor: '#ffa2a2',
    theirVoteColor: '#ff0000',
  };
};
